import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Col, Grid, Row } from 'react-flexbox-grid'
import * as Constants from '../../../constants'
import { Button, message, Tabs } from 'antd'
import LoadingPage from '../../components/LoadingPage'
import { loadInventory, removeItemInventory } from '../../../actions/inventory'
import { getInventory } from '../../../reducers'
import { connect } from 'react-redux'
import InventoryVehiclesTable from '../../components/InventoryVehiclesTable'
import InventoryToolsTable from '../../components/InventoryToolsTable'
import './style.css'

const { TabPane } = Tabs

const Inventory = (props) => {
    const [loading, setLoading] = useState(false)

    const tapNewVehicle = () => {
        props.history.push(`/${Constants.MenuAdmin.INVENTORY.NEW_VEHICLE}`)
    }

    const tapNewTool = () => {
        props.history.push(`/${Constants.MenuAdmin.INVENTORY.NEW_TOOL}`)
    }

    const getInventory = () => {
        props.loadInventory()
        return <LoadingPage/>
    }

    const showReservationsVehicle = inventory => {
        message.info('Próximamente')
    }

    const editVehicle = inventory => {
        props.history.push(`/${Constants.MenuAdmin.INVENTORY.EDIT_VEHICLE}/${inventory.id}`)
    }

    const removeVehicle = async inventory => {
        setLoading(true)
        const response = await props.removeItemInventory(inventory)
        setLoading(false)
        if (response) {
            message.success('El vehículo se borró exitósamente')
        } else {
            message.error('Se produjo un error. Por favor, vuelva a intentarlo')
        }
    }

    const renderTableVehicles = inventory => {
        const inventoryData = Object.values(inventory).filter(data => data.type && data.type === Constants.INVENTORY_TYPES.VEHICLE)
        return <InventoryVehiclesTable data={inventoryData} onRemoveVehicle={removeVehicle} onEditVehicle={editVehicle}
                                       onShowReservations={showReservationsVehicle} loading={loading}/>
    }

    const showReservationsTool = inventory => {
        message.info('Próximamente')
    }

    const editTool = inventory => {
        props.history.push(`/${Constants.MenuAdmin.INVENTORY.EDIT_TOOL}/${inventory.id}`)
    }

    const removeTool = async inventory => {
        setLoading(true)
        const response = await props.removeItemInventory(inventory)
        setLoading(false)
        if (response) {
            message.success('La herramienta se borró exitósamente')
        } else {
            message.error('Se produjo un error. Por favor, vuelva a intentarlo')
        }
    }

    const renderTableTools = inventory => {
        const inventoryData = Object.values(inventory).filter(data => data.type && data.type === Constants.INVENTORY_TYPES.TOOL)
        return <InventoryToolsTable data={inventoryData} onRemoveTool={removeTool} onEditTool={editTool}
                                       onShowReservations={showReservationsTool} loading={loading}/>
    }

    return (
        <Grid className="inventoryCont">
            {
                props.inventory ?
                    <Row center="xs">
                        <Col xs={12}>
                            <div className="card-container">
                                <Tabs type="card">
                                    <TabPane tab="Vehículos" key="1">
                                        <Button onClick={tapNewVehicle}>Nuevo Vehiculo</Button>
                                        {
                                            renderTableVehicles(props.inventory)
                                        }
                                    </TabPane>
                                    <TabPane tab="Herramientas" key="2">
                                        <Button onClick={tapNewTool}>Nueva Herramienta</Button>
                                        {
                                            renderTableTools(props.inventory)
                                        }
                                    </TabPane>
                                </Tabs>
                            </div>
                        </Col>
                    </Row>
                    :
                    getInventory()
            }
        </Grid>
    )
}

const mapDispatchToPropsActions = dispatch => ({
    loadInventory: value => dispatch(loadInventory(value)),
    removeItemInventory: value => dispatch(removeItemInventory(value))
})

const mapStateToProps = state => ({
    inventory: getInventory(state)
})

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(Inventory))
